// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"256":"be06da35","674":"0cf79dbd","708":"be06da35","745":"be06da35"}[chunkId] + ".chunk.css";
};